import { INotesListFilters } from '~/services/api/notes/types';

const initialValues: INotesListFilters = {
  startDate: '',
  endDate: '',
  isTelephoneConversation: '',
};

export default initialValues;
